<h1 arkik-dialog-title>{{ data.title }}</h1>

<div arkik-dialog-content>
  <p>
    {{ data.message }}
  </p>

  <div class="assigned" *ngIf="data.warning">
    <cwc-icon name="warning-rounded-fill" size="18px" color="bright-orange"></cwc-icon>
    <span>{{ data.warning }}</span>
  </div>
</div>

<div arkik-dialog-actions>
  <ng-container *ngIf="!data.hideCancelBtn">
    <cwc-button type="button" variant="support" (click)="onCancel()">{{ data.cancelButton }}</cwc-button>
  </ng-container>
  <cwc-button type="button" variant="regular" (click)="onOk()">{{ data.okButton }}</cwc-button>
</div>
